module.exports = require('@bugsnag/browser')



//////////////////
// WEBPACK FOOTER
// ./~/@bugsnag/js/browser/notifier.js
// module id = WdoM
// module chunks = 0